import React from 'react'
import styled from 'styled-components'
import { Tag, Flex, Heading, useMatchBreakpoints, TokenPairImage, TokenPairImageV2 } from '@pancakeswap/uikit'
import { CommunityTag, CoreTag } from 'components/Tags'

export interface ExpandableSectionProps {
  lpLabel?: string
  multiplier?: string
  isCommunityFarm?: boolean
  token: string
  quoteToken: string,
  tokenSymbol:string,
  quoteTokenSymbol:string
  poolId:number
}

const Wrapper = styled(Flex)`
  height: 80px;
  background-size: 100% 100%;
    svg {
    margin-right: 4px;
  }
`
const CustomHeading = styled(Heading)`
  color: ${({ theme }) => theme.colors.text};
  font-size:14px;
  font-weight: bold;
`
const getImageUrlFromToken = (token: string) => {
  return `/images/coins/${token.toLowerCase()}.png`
}

const CardHeading: React.FC<ExpandableSectionProps> = ({ lpLabel, multiplier, isCommunityFarm, token, quoteToken, tokenSymbol, quoteTokenSymbol, poolId }) => {
  const { isXl } = useMatchBreakpoints()
  const isMobile = isXl === false
  
  return (
    <Wrapper justifyContent="space-between" alignItems="start">
      { poolId === 0 ?
          <TokenPairImageV2 variant="default" secondarySrc={getImageUrlFromToken(quoteTokenSymbol)} thirdSrc="https://s2.coinmarketcap.com/static/img/coins/64x64/16193.png" width={100} height={100} />
      :
          <TokenPairImage variant="default" primarySrc={getImageUrlFromToken(tokenSymbol)} secondarySrc={getImageUrlFromToken(quoteTokenSymbol)} thirdSrc="https://s2.coinmarketcap.com/static/img/coins/64x64/16193.png" width={100} height={100} />
      }
      <Flex ml="20px" width='60%' flexDirection="column" alignItems="start" style={{marginTop:isMobile ? "5px" : "0px"}}>
            <Flex width="100%" justifyContent="flex-start">
                {isCommunityFarm ? <CommunityTag /> : <CoreTag />}
            </Flex>
            <Heading mt="4px" color='text'>{lpLabel.split(' ')[0]}</Heading>
            <CustomHeading mt="5px">Earn Pi</CustomHeading>
      </Flex>
    </Wrapper>
  )
}

export default CardHeading
